@import '@client/theme/theme.less';

.filters {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;
}

.spacer {
  flex: 1;
}

.empty {
  padding: 24px 0;
}
